export enum PaymentMethod {
  Basic = "basic",
  Card = "card",
}
